import type { ReactNode } from "react";

export enum ExpandablePanelVariant {
    Default = "default",
    Nested = "nested",
}

type ExpandablePanelBaseProps = {
    title: ReactNode;
    children: ReactNode;
    className?: string;
    /** `Nested`: bordered card, compact header padding (e.g. accordion inside another panel). */
    variant?: ExpandablePanelVariant;
    dataAutomation?: string;
    defaultOpen?: boolean;
    isOpen?: boolean;
    onToggle?: (open: boolean) => void;
};

export type ExpandablePanelWithPersistence = ExpandablePanelBaseProps & {
    persistOpenState: true;
    persistenceKey: string;
};

export type ExpandablePanelWithoutPersistence = ExpandablePanelBaseProps & {
    persistOpenState?: false;
    persistenceKey?: undefined;
};

export type ExpandablePanelProps = ExpandablePanelWithPersistence | ExpandablePanelWithoutPersistence;
